import React, { memo, useCallback } from 'react';
import { cx } from '@emotion/css';
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDateFns } from '@mui/x-date-pickers-pro/AdapterDateFns';
import { StaticDateRangePicker as MUIStaticDateRangePicker } from '@mui/x-date-pickers-pro/StaticDateRangePicker';
import { useStyles } from './StaticDateRangePicker.styles';
export const StaticDateRangePicker = memo(function (props) {
    const classes = useStyles();
    const dayOfWeekFormatter = useCallback((day) => `${day.charAt(0).toUpperCase()}${day.charAt(1)}`, []);
    const renderInput = useCallback(() => React.createElement(React.Fragment, null), []);
    return (React.createElement(LocalizationProvider, { dateAdapter: AdapterDateFns },
        React.createElement("div", { className: cx(classes.root, props.className), id: props.id },
            React.createElement(MUIStaticDateRangePicker, { dayOfWeekFormatter: dayOfWeekFormatter, disableFuture: props.disableFuture, disablePast: props.disablePast, displayStaticWrapperAs: "desktop", onChange: props.onChange, onError: props.onError, maxDate: props.maxDate, minDate: props.minDate, renderInput: renderInput, value: props.value }))));
});
//# sourceMappingURL=StaticDateRangePicker.js.map